import type { JSX } from "react";
import Icon from "../Icon";

export interface LocationTypeIconOverride {
  type?: string | null;
  image?: string | null;
}

export default function LocationTypeIcon({
  className,
  color,
  type,
  typeKey,
  overrides,
  loading,
}: {
  className?: string;
  color?: string;
  type?: string;
  typeKey?: string;
  overrides?: LocationTypeIconOverride[];
  loading?: boolean;
}): JSX.Element | null {
  let icon = "locationMarker";
  if (type) {
    let displayType = type;
    if (overrides) {
      const match = overrides.find((opt) => opt.type === typeKey);
      if (match && match.image) displayType = match.image;
    }

    icon =
      {
        airport: "airport",
        attraction: "attraction",
        cruise: "cruise",
        food: "food",
        generic: "locationMarker",
        health: "health",
        hotel: "hotel",
        house: "house",
        locality: "globe",
        nature: "nature",
        road: "road",
        school: "school",
        store: "store",
        train: "train",
      }[displayType] || "locationMarker";
  }

  return loading ? null : <Icon className={className} color={color} type={icon} />;
}
